/* eslint-disable */
import React from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";

export default function BrowserStates() {
  let products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const isClassicMode = (account?.productMode ?? "classic") === "classic";
  if (isClassicMode) {
    products = products.filter(
      (product) =>
        product.type !== "digitalProducts" 
    );
  } else {
    products = products.filter(
      (product) =>
        product.type === "digitalProducts" 
    );
  }
  const sortedProducts = products.sort((a, b) => b.visits - a.visits);
  const topFiveProducts = sortedProducts.slice(0, 5);
  const totalVisits = store.visits || 1;
  const hasProducts = topFiveProducts.length > 0;
  const { t, i18n } = useTranslation();
  const truncateName = (name) => {
    return name.length > 17 ? name.substring(0, 17) + "..." : name;
  };

  // Color palette that matches our dashboard cards
  const colors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];

  const renderStates = () => {
    if (!hasProducts) {
      return (
        <div className="flex flex-col items-center justify-center py-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-gray-300 mb-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
          <span className="text-gray-500 font-medium">{t("dashboard.BrowserStates.noPrducts")}</span>
          <span className="text-gray-400 text-sm mt-1">
           {t("dashboard.BrowserStates.addProducts")}
          </span>
        </div>
      );
    }

    return topFiveProducts.map((product, index) => {
      const visitPercentage = ((product.visits / totalVisits) * 100).toFixed(1);
      const color = colors[index % colors.length];

      return (
        <div
          key={product.id || index}
          className="flex items-center justify-between py-3 border-b border-gray-100 dark:!border-[#3c3a3d] last:border-0"
        >
          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <div className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] overflow-hidden border-2 border-gray-100 shadow-sm">
              <img
                src={product.image || "/product-foorweb.png"}
                className="w-full h-full object-cover"
                alt={product.name}
              />
            </div>
            <div>
              <p className="font-medium text-gray-800 dark:text-white m-0">
                {truncateName(product.name)}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 m-0">
                {product.visits} {t("dashboard.BrowserStates.vues")}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <span className="font-bold text-lg" style={{ color }}>
              {visitPercentage}%
            </span>
            <Chart
              options={{
                grid: {
                  show: false,
                  padding: {
                    left: -10,
                    right: -10,
                    top: -10,
                    bottom: -10,
                  },
                },
                colors: [color],
                plotOptions: {
                  radialBar: {
                    hollow: { size: "50%" },
                    track: { background: "#f1f5f9" },
                    dataLabels: {
                      show: false,
                    },
                  },
                },
                stroke: { lineCap: "round" },
              }}
              series={[parseFloat(visitPercentage)]}
              type="radialBar"
              height={40}
              width={40}
            />
          </div>
        </div>
      );
    });
  };

  return (
    <div className="bg-white dark:!bg-[#181919] col-span-1 md:col-span-2 rounded-lg shadow-sm w-full h-[400px] dark:border dark:border-[#3c3a3d]">
      <div className="p-4 flex flex-col h-full">
        <div className="flex justify-between items-center mb-4 shrink-0">
          <h5 className="font-bold text-lg text-gray-800 m-0 dark:text-white">{t("dashboard.BrowserStates.title")}</h5>
          <p className="text-sm bg-blue-50 dark:!bg-[#141414] text-blue-600 dark:text-blue-50 px-3 py-1 rounded-full m-0">
            {store?.visits || 0} {t("dashboard.BrowserStates.vues")}
          </p>
        </div>

        <div
          className="overflow-y-auto overflow-x-hidden flex-1 scrollbar-hide"
          style={{
            msOverflowStyle: "none", // for IE and Edge
            scrollbarWidth: "none", // for Firefox
          }}
        >
          <div className="divide-y divide-gray-100 dark:!divide-[#3c3a3d]">{renderStates()}</div>
        </div>
      </div>
    </div>
  );
}
